import { Gender } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { personName } from '../_shared/person-name.js';
export const airportOptionSchema = z.object({
    category: z.string().optional(),
    label: z.string(),
    value: z.string(),
});
const optionSchema = z.object({
    label: z.string(),
    value: z.string(),
});
export const companyPreferenceSchema = z.object({
    companyName: optionSchema,
    hasPreference: z.boolean(),
});
export const flightLegSchema = z.object({
    date: z.string(),
    departure: airportOptionSchema,
    destination: airportOptionSchema,
    flexibilityAfter: z.number().int().min(0),
    flexibilityBefore: z.number().int().min(0),
});
export const passengerSchema = z.object({
    firstName: personName(),
    lastName: personName(),
    birthDate: z.string(),
    gender: z.nativeEnum(Gender),
    nationality: z.string(),
});
